<div class="game-period-filters">
  <mtg-dropdown
    *ngIf="!team.sport.isStreetball()"
    [formControl]="periodControl"
    variant="button"
    label="Тайм"
    [errorVisible]="false"
  >
    <mtg-dropdown-item
      *ngFor="let period of periods"
      [value]="period"
    >{{ period }} тайм
    </mtg-dropdown-item>
    <mtg-dropdown-item
      *ngFor="let p of overtimePeriods"
      [value]="p"
    >{{ p - game.handballGameConfig.periodsCount }} доп. тайм
    </mtg-dropdown-item>
  </mtg-dropdown>
  <mtg-dropdown
    [formControl]="positionControl"
    label="Позиция"
    variant="button"
    [errorVisible]="false"
  >
    <mtg-dropdown-item
      *ngFor="let value of positions"
      [value]="value"
    >{{ value | localization: positionLocalization }}</mtg-dropdown-item>
  </mtg-dropdown>
  <div class="search">
    <mtg-text-field
      size="sm"
      placeholder="Искать игрока..."
      [formControl]="query"
      trailingIcon="icons-search"
    ></mtg-text-field>
  </div>
</div>

<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col>
      <div class="team">
        <div class="logo">
          <a [routerLink]="getTeamRoute(team.id)">
            <img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name"/>
            <div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
          </a>
        </div>
        <div class="name">
          <a [routerLink]="getTeamRoute(team.id)">{{ team.name }}</a>
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group title="Очки">
      <mtg-table-col>голы</mtg-table-col>
      <mtg-table-col>ассисты</mtg-table-col>
      <mtg-table-col>всего</mtg-table-col>
      <mtg-table-col>% реализации</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Броски">
      <mtg-table-col>всего</mtg-table-col>
      <mtg-table-col>в створ</mtg-table-col>
      <mtg-table-col>меткость</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="7м">
      <mtg-table-col>забитые</mtg-table-col>
      <mtg-table-col>всего</mtg-table-col>
      <mtg-table-col>% реализации</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>потери</mtg-table-col>
    <mtg-table-col-group title="Защита">
      <mtg-table-col>перехваты</mtg-table-col>
      <mtg-table-col>блоки</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Наказания">
      <mtg-table-col>желтые карточки</mtg-table-col>
      <mtg-table-col>красные карточки</mtg-table-col>
      <mtg-table-col>2’</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-header-row>
  <mtg-table-row>
    <mtg-table-identity-col>
      <div class="total-title">
        <mtg-svg-icon icon="icons-handball"></mtg-svg-icon>
        Всего
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ getTotal('totalGoals') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('assists') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('points') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getTotal('totalGoals'), getTotal('shots')) }}%</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getTotal('shots') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('shotsOnGoal') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getTotal('shotsOnGoal'), getTotal('shots')) }}%</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getTotal('penaltyGoals') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('penaltyShots') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getTotal('penaltyGoals'), getTotal('penaltyShots')) }}%</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>{{ getTotal('turnovers') }}</mtg-table-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ getTotal('steals') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('blockShots') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getTotal('yellowCards') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('redCards') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('twoMinuteFouls') }}</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-row>
  <mtg-table-row *ngFor="let user of players; trackBy: identify">
    <mtg-table-identity-col>
      <div class="number">{{ user.gameUserNumber || '–' }}</div>
      <div class="photo">
        <a [routerLink]="getUserProfileRoute(user)">
          <ng-container *ngIf="!user.tournamentTeamUser.id">
            <img [src]="user.teamUser.user.photo.path"
                 *ngIf="user.teamUser.user.photo.path"
                 class="circle-image"/>
            <div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
          </ng-container>
          <ng-container *ngIf="user.tournamentTeamUser.id">
            <img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
                 *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
                 class="circle-image"/>
            <div class="empty-photo"
                 *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
          </ng-container>
        </a>
      </div>
      <div class="info">
        <a [routerLink]="getUserProfileRoute(user)">
          <ng-container *ngIf="user.tournamentTeamUser.id">
            <div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
          </ng-container>
          <ng-container *ngIf="!user.tournamentTeamUser.id">
            <div class="name">{{ user.teamUser.user.shortName }}</div>
          </ng-container>
          <div
            class="text-muted">{{ user.teamUser.user.handballProfile.position | localization: positionLocalization }}</div>
        </a>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'totalGoals') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'assists') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'points') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'totalGoals'), getUserStatistic(user.id, 'shots')) }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'shots') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'shotsOnGoal') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'shotsOnGoal'), getUserStatistic(user.id, 'shots')) }}%
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'penaltyGoals') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'penaltyShots') }}</mtg-table-col>
      <mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'penaltyGoals'), getUserStatistic(user.id, 'penaltyShots')) }}
        %
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>{{ getUserStatistic(user.id, 'turnovers') }}</mtg-table-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'steals') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'blockShots') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'yellowCards') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'redCards') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'twoMinuteFouls') }}</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-row>
</mtg-table>

<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col>
      <div class="team">
        <div class="name">
          Вратари
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group title="Надежность">
      <mtg-table-col>всего бросков</mtg-table-col>
      <mtg-table-col>пропущено</mtg-table-col>
      <mtg-table-col>сейвы</mtg-table-col>
      <mtg-table-col>% сейвов</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="7м">
      <mtg-table-col>сейвы</mtg-table-col>
      <mtg-table-col><span class="text-muted">всего</span></mtg-table-col>
      <mtg-table-col>% сейвов</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>Мин.</mtg-table-col>
    <mtg-table-col>+/-</mtg-table-col>
  </mtg-table-header-row>
  <mtg-table-row *ngFor="let user of goalkeepers; trackBy: identify">
    <mtg-table-identity-col>
      <div class="number">{{ user.gameUserNumber || '–' }}</div>
      <div class="photo">
        <a [routerLink]="getUserProfileRoute(user)">
          <ng-container *ngIf="!user.tournamentTeamUser.id">
            <img [src]="user.teamUser.user.photo.path"
                 *ngIf="user.teamUser.user.photo.path"
                 class="circle-image"/>
            <div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
          </ng-container>
          <ng-container *ngIf="user.tournamentTeamUser.id">
            <img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
                 *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
                 class="circle-image"/>
            <div class="empty-photo"
                 *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
          </ng-container>
        </a>
      </div>
      <div class="info">
        <a [routerLink]="getUserProfileRoute(user)">
          <ng-container *ngIf="user.tournamentTeamUser.id">
            <div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
          </ng-container>
          <ng-container *ngIf="!user.tournamentTeamUser.id">
            <div class="name">{{ user.teamUser.user.shortName }}</div>
          </ng-container>
          <div
            class="text-muted">{{ user.teamUser.user.handballProfile.position | localization: positionLocalization }}</div>
        </a>
      </div>
    </mtg-table-identity-col>

    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'shotsAgainst') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'totalGoalsAgainst') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'saves') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'savesPercent') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getUserStatistic(user.id, 'penaltySaves') }}</mtg-table-col>
      <mtg-table-col><span class="text-muted">{{ getUserStatistic(user.id, 'penaltyShotsAgainst') }}</span>
      </mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'penaltySavesPercent') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col>{{ userMinutes[user.id] || 0 }}</mtg-table-col>
    <mtg-table-col>{{ userEfficiency[user.id] || 0 }}</mtg-table-col>
  </mtg-table-row>
</mtg-table>

